import type { Dispatch } from '@reduxjs/toolkit';
import { setToken, setUser } from '../redux/auth/authSlice';
import { User } from '../types';

/** firebaseService のログイン系関数がバックエンド認証後に返す形 */
export interface FirebaseAuthResult {
  token: string;
  user: User;
}

/**
 * Firebase ログイン（パスワード / Google / 招待受諾直後）の結果を auth state に反映する。
 *
 * ここを経由せずに `login` thunk へ結果を渡すと `POST /api/auth/login` に
 * email/password が無いまま飛んで必ず 422 になる（招待受諾後の自動ログインが
 * これで壊れていた）。Firebase 経由のログインはバックエンド認証済みのトークンを
 * 既に持っているので、同期 reducer にそのまま入れるのが正しい。
 *
 * `setToken` が tokenManager への保存と isAuthenticated=true までやる。
 * 遷移先は呼び出し側が `getPostAuthDestination(result.user)` で決める。
 */
export const applyAuthResult = (
  dispatch: Dispatch,
  result: FirebaseAuthResult,
): void => {
  dispatch(setUser(result.user));
  dispatch(setToken(result.token));
};

export default applyAuthResult;
